import React from 'react'

import { connect } from 'react-redux'

import BasePureComponent from 'utils/BasePureComponent'
import Input from 'components/Input'

import {
  addExtraData,
  updateExtraData,
  deleteExtraData,
} from 'scenes/VehicleDetail/components/Policy/actions'


export class EditExtraDataForm extends BasePureComponent {
  constructor(props) {
    super(props)

    this.state = {
      key: '',
      value: ''
    }

    this._bind('_renderExtra', '_onAdd', '_onDelete', '_onChange', '_onExtraChange')
  }

  _renderExtra(extraId) {
    const extra = this.props.extra_data[extraId]

    return (
      <div key={extraId} className="VehicleDetailPolicyTab__AdditionalData-row created">
        <Input
          label="Campo"
          name={`${extraId}_key`}
          onChange={this._onExtraChange}
          value={extra.key} />
        <Input
          label="Valor"
          name={`${extraId}_value`}
          onChange={this._onExtraChange}
          value={extra.value} />
        <div className="button-wrapper">
          <button onClick={() => this._onDelete(extraId)} className="delete">
            <i className="material-icons">delete_forever</i>
          </button>
        </div>
      </div>
    )
  }

  _onExtraChange(evt) {
    const [uuid, type] = evt.target.name.split('_')
    this.props.updateExtra(uuid, evt.target.value, type === 'key')
  }

  _onDelete(id) {
    this.props.deleteExtra(id)
  }

  _onAdd(evt) {
    evt.preventDefault()

    if (!this.state.key || !this.state.value)
      return

    this.props.addExtra(this.state.key, this.state.value)
    this.setState({ key: '', value: '' })
  }

  _onChange(evt) {
    this.setState({ [evt.target.name]: evt.target.value })
  }

  render() {
    return (
      <div>
        {this.props.extra_data_order.map(this._renderExtra)}
        <div className="VehicleDetailPolicyTab__AdditionalData-row">
          <Input
            label="Campo"
            name="key"
            onChange={this._onChange}
            value={this.state.key} />
          <Input
            label="Valor"
            name="value"
            onChange={this._onChange}
            value={this.state.value} />
          <div className="button-wrapper">
            <button onClick={this._onAdd}  className="add">
              <i className="material-icons">add</i> Agregar
            </button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    extra_data: state.policyVehicleDetail.get('extra_data').toJS(),
    extra_data_order: state.policyVehicleDetail.get('extra_data_order').toArray()
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    deleteExtra: (id) => dispatch(deleteExtraData(id)),
    updateExtra: (uuid, inputValue, isKey) => dispatch(updateExtraData(uuid, inputValue, isKey)),
    addExtra: (key, value) => dispatch(addExtraData(key, value))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(EditExtraDataForm)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Policy/AdditionalData/EditExtraDataForm.js